import { Section } from "modules/layout";
import { ProfileAvatarForm, ProfileNameForm } from "modules/profile";
import React from "react";
import ProfileLayout from "./_layout";
import style from "./index.page.module.scss";

const ProfilePage = () => {
  return (
    <ProfileLayout>
      <div className={style.profile}>
        <Section>
          <ProfileAvatarForm />
        </Section>
        <Section>
          <ProfileNameForm />
        </Section>
      </div>
    </ProfileLayout>
  );
};

export default ProfilePage;
